/**
 * Filter State Reducer
 * Manages filter and selection-related state
 */

export const filterStateActions = {
    SET_SELECTED_USERS: 'SET_SELECTED_USERS',
    SET_SELECTED_CATEGORIES: 'SET_SELECTED_CATEGORIES',
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    SET_SELECT_ALL: 'SET_SELECT_ALL',
    SET_LEAVE_FILTER_USERS: 'SET_LEAVE_FILTER_USERS',
    SET_LEAVE_SEARCH_TERM: 'SET_LEAVE_SEARCH_TERM',
    SET_SELECT_ALL_LEAVE_USERS: 'SET_SELECT_ALL_LEAVE_USERS',
};

const initialState = {
    selectedUsers: [],
    selectedCategories: [],
    googleMicrosoftUserSearchTerm: '',
    selectAllUsers: false,
    leaveFilterUsers: [],
    leaveUserSearchTerm: '',
    selectAllLeaveUsers: false,
};

export const filterStateReducer = (state, action) => {
    switch (action.type) {
        case filterStateActions.SET_SELECTED_USERS:
            return {
                ...state,
                selectedUsers: action.users,
            };
        
        case filterStateActions.SET_SELECTED_CATEGORIES:
            return {
                ...state,
                selectedCategories: action.categories,
            };
        
        case filterStateActions.SET_SEARCH_TERM:
            return {
                ...state,
                googleMicrosoftUserSearchTerm: action.term,
            };
        
        case filterStateActions.SET_SELECT_ALL:
            return {
                ...state,
                selectAllUsers: action.value,
            };
        
        case filterStateActions.SET_LEAVE_FILTER_USERS:
            return {
                ...state,
                leaveFilterUsers: action.users,
            };
        
        case filterStateActions.SET_LEAVE_SEARCH_TERM:
            return {
                ...state,
                leaveUserSearchTerm: action.term,
            };
        
        case filterStateActions.SET_SELECT_ALL_LEAVE_USERS:
            return {
                ...state,
                selectAllLeaveUsers: action.value,
            };
        
        default:
            return state;
    }
};

